module.exports = "<div id=\"infoBox\" class=\"noscrollbar info-box\">\n  <strong><%= content %></strong>\n  <div class=\"row\">\n    <div class=\"col-xs-12\"><p style=\"font-size:14px;padding-top:5%;\">Click a Property</p></div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./client/templates/initialWindow.html
// module id = 1L7t
// module chunks = 1